import { render, staticRenderFns } from "./modalGeofence.vue?vue&type=template&id=1973218c&"
import script from "./modalGeofence.vue?vue&type=script&lang=js&"
export * from "./modalGeofence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports